import { formatAsTitle } from '@/utils/format'
import type { TabType } from './types'
import { AlertStatuses } from '@/api/types/Alert'

const watchdogTabsKeys = [...AlertStatuses.map(status => status.toLowerCase()), 'all']

export type WatchdogTabsKeys = typeof watchdogTabsKeys[number]

const watchdogTabs: TabType[] = watchdogTabsKeys.map(key => ({
  url: key,
  label: formatAsTitle(key),
}))

export default watchdogTabs
